import { useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { useApi } from "@/lib/api";

export function useMe() {
  const { isSignedIn, isLoaded } = useAuth();
  const call = useApi();
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isLoaded) return;
    if (!isSignedIn) {
      setMe(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    call("get", "/me")
      .then((r) => setMe(r.data))
      .catch(() => setMe(null))
      .finally(() => setLoading(false));
  }, [isSignedIn, isLoaded, call]);

  return { me, loading, isSignedIn };
}
